const config = {
  publicKey: process.env.REACT_APP_JWT_PUBLIC_KEY || 'secret',
  algorithm: process.env.REACT_APP_JWT_ALGORITHM || 'RS512'
}

export default config
